import TokenService from "./token-service";

export function isStaffRole(role) {
  const r = String(role || TokenService.getUserRole() || "").toLowerCase();
  return r === "employee" || r === "manager";
}

/** List/search scope for employee & manager (clients, invoices, contracts). */
export function buildAssignedClientScopeParams(params = {}) {
  if (!isStaffRole()) return { ...params };

  // Reports / date-range / revenue APIs use their own filters
  if (
    params.revenue_by_employee ||
    params.start_date ||
    params.end_date ||
    params.collection
  ) {
    return { ...params };
  }

  const userId = TokenService.getUserID();
  const search = String(params.search ?? "").trim();
  const hasSearch = search.length > 0;
  const scope = params.scope || (hasSearch ? "all" : "assigned");
  const out = { ...params, scope };

  if (scope === "assigned") {
    out.assigned_by = userId;
    if (!hasSearch) delete out.search;
  } else {
    delete out.assigned_by;
    if (hasSearch) out.search = search;
  }

  return out;
}
